/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: pfy
 * @Date: 2019-07-19 17:41:19
 * @LastEditTime: 2019-09-02 21:17:25
 */
import { logistice, authorization } from '@/utils/request'
import { AUTHORIZATION_BASEAPI, LOGISTICE_GATEWAY, AUTHORIZATION_GATEWAY } from '@/utils/settings' // 请求接口

const BASE = `${LOGISTICE_GATEWAY}/website`
const BASE_API = `${LOGISTICE_GATEWAY}/website/index/systemUser`

// 用户名登录 ${LOGISTICE_GATEWAY}
export function login(params) {
  return authorization({
    url: `/auth/oauth/token`,
    method: 'post',
    headers: {
      'Authorization': 'Basic bWFyczptYXJz'
    },
    params
  })
}
// 验证码登录
// export function codeLogin(params) {
//   return authorization({
//     url: `${AUTHORIZATION_GATEWAY}/auth/mobile/token/sms`,
//     method: 'post',
//     headers: {
//       'Authorization': 'Basic bWFyczptYXJz'
//     },
//     params
//   })
// }
// 手机号登录
export function phoneLogin(params) {
  return logistice({
    url: `${AUTHORIZATION_BASEAPI}${AUTHORIZATION_GATEWAY}/auth/mobile/token/sms` + params,
    method: 'post',
    headers: {
      'Authorization': 'Basic bWFyczptYXJz'
    },
    data: {}
  })
  // return logistice({
  //   url: `${BASE}/index/systemUser`,
  //   method: 'post',
  //   params
  // })
}

// 获取用户信息
export function getInfo() {
  return logistice({
    url: `${BASE}/sys/api/user`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({ methodName: 'getUserInfo' }))
    }
  })
}

// 获得企业信息
export function getCompanyInfo(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/authentication/get`,
    method: 'post',
    data: Object.assign({
      methodName: 'findById'
    }, params)
  })
}
// 注册
export function reg(params) {
  return logistice({
    url: `${BASE}/index/systemUser`,
    method: 'post',
    params
  })
}

// 登出
export function logout() {
  return logistice({
    // url: `${BASE}/index/systemUser`,
    method: 'post',
    data: {
      mehtodName: 'logOut'
    }
  })
}
// 手机号验证（查重）
export const getPhoneIf = (params) => {
  return logistice({
    url: BASE_API,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findByPhone'
      }, params))
    }
  })
}
// 平台协议
export function findCmsPlatformProtocol(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + '/website/index/cmsPlatformProtocolManager',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCmsPlatformProtocol'
      }, param))
    }
  })
}
// 平台协议 是否已经不再提示
export function upateStatus(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + '/website/index/cmsPlatformProtocolManager',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'upateStatus'
      }, param))
    }
  })
}
